import ConfirmationDialog from "@/components/ui/ConfirmationDialog";
import { useTranslation } from "react-i18next";

type SupportSessionTimeoutModalProps = {
  open: boolean;
  onReturnToSupportAdmin: () => void;
};

export default function SupportSessionTimeoutModal({
  open,
  onReturnToSupportAdmin,
}: SupportSessionTimeoutModalProps) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <ConfirmationDialog
      open
      showClose={false}
      singleButton
      title={t("super_admin.support_mode.session_timeout.title")}
      message={t("super_admin.support_mode.session_timeout.message")}
      confirmButtonText={t(
        "super_admin.support_mode.session_timeout.return_to_support_admin_button"
      )}
      onConfirm={onReturnToSupportAdmin}
    />
  );
}
